module.exports = __webpack_public_path__ + "img/avatar5.d58bc5c9.png";